import Navbar from "@/components/sections/Navbar";
import Hero from "@/components/sections/Hero";
import Marquee from "@/components/sections/Marquee";
import About from "@/components/sections/About";
import PortfolioGrid from "@/components/sections/PortfolioGrid";
import Services from "@/components/sections/Services";
import Process from "@/components/sections/Process";
import Testimonials from "@/components/sections/Testimonials";
import CtaBanner from "@/components/sections/CtaBanner";
import Contact from "@/components/sections/Contact";
import Footer from "@/components/sections/Footer";

export default function Portfolio() {
    return (
        <main className="font-body bg-white text-ink" data-testid="portfolio-page">
            <Navbar />
            <Hero />
            <Marquee />
            <About />
            <PortfolioGrid />
            <Services />
            <Process />
            <Testimonials />
            <CtaBanner />
            <Contact />
            <Footer />
        </main>
    );
}
